'use strict';

exports.decode = exports.parse = require('./decode');
exports.encode = exports.stringify = require('./encode');



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-scripts/~/querystring/index.js
 ** module id = 384
 ** module chunks = 0
 **/